
export default {
  name: 'BreadcrumbsMobile',
  props: {
    links: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    link() {
      if (this.links?.length <= 1) {
        return null
      }

      return this.links[this.links.length - 2]
    },
    iconTheme() {
      return this.$store.state.theme.currentThemeIconContrast
    },
  },
}
